import { api } from './api';

export type MonitoringSeverity = 'info' | 'warning' | 'error' | 'critical';
export type MonitoringCategory =
  | 'system'
  | 'validation'
  | 'security'
  | 'network'
  | 'unknown';

export interface MonitoringPayload {
  message: string;
  formName?: string;
  route?: string;
  details?: string;
  stack?: string;
  severity?: MonitoringSeverity;
  category?: MonitoringCategory;
  source?: string;
  userEmail?: string;
  userId?: string;
  tags?: string[];
  validationErrors?: Array<{ field: string; message: string }>;
}

export const monitoringService = {
  async reportError(payload: MonitoringPayload): Promise<void> {
    const normalizedPayload: MonitoringPayload = {
      ...payload,
      source: payload.source || 'frontend',
    };

    await api.post('/monitoring/errors', normalizedPayload, {
      headers: {
        'x-monitoring-client': 'web',
      },
    });
  },
};
